<dish-admin>
  <ng-container>
    <dish-client-location-select
      (selectChange)="fetchImportErrorsOnChange(); resetDate()"
      (clientHasBeenChanged)="resetImportErrors()">
      <div class="col-sm-12 col-lg-3 col-xl-2 align-self-end date-select-wrapper">
				<label class="font-weight-bold">Date <span class="font-weight-normal small">(Optional)</span>:</label>
				<mat-form-field subscriptSizing="dynamic" appearance="outline">
					<input
						[formControl]="dateControl"
						matInput
						[matDatepicker]="picker"
						placeholder="(Optional): Choose a Date"
						(dateChange)="dateChange($event.value)">
					<mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
			</div>
			<div class="col-sm-12 col-lg-3 col-xl-2 align-self-end error-code-select-wrapper">
				<label class="font-weight-bold">Error Code <span class="font-weight-normal small">(Optional)</span>:</label>
				<mat-form-field subscriptSizing="dynamic" appearance="outline">
					<mat-select
						data-testid="error-code-select"
						placeholder="(Optional): Error Code"
						[formControl]="codeControl"
						(selectionChange)="onCodeChange($event.value)">
						<mat-option [value]="null">All Codes</mat-option>
						@for (e of errorCodes; track e) {
							<mat-option [value]="e.code">{{ e.friendlyName }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
    </dish-client-location-select>
  </ng-container>

  <table mat-table [dataSource]="dataSource" matSort>

    <!-- No data-->
    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No matching import errors found.
      </td>
    </tr>

    <!-- Client Id -->
    <ng-container matColumnDef="clientName">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Client Name</th>
      <td mat-cell *matCellDef="let importError" class="text-left"> {{importError.clientName}} </td>
    </ng-container>

    <!-- Location Id -->
    <ng-container matColumnDef="locationName">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Location Name</th>
      <td mat-cell *matCellDef="let importError" class="text-left"> {{importError.locationName}} </td>
    </ng-container>

    <!-- Code -->
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef> Error Code</th>
      <td mat-cell *matCellDef="let importError"> {{importError.code}} </td>
    </ng-container>

    <!-- Object Id -->
    <ng-container matColumnDef="objectId">
      <th mat-header-cell *matHeaderCellDef class="text-left">Id</th>
      <td mat-cell *matCellDef="let importError" class="text-left"> {{importError.objectId}} </td>
    </ng-container>

    <!-- Message -->
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Error Message</th>
      <td mat-cell *matCellDef="let importError" class="text-left"> {{importError.message}} </td>
    </ng-container>

    <!-- Resolution -->
    <ng-container matColumnDef="resolution">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Resolution</th>
      <td mat-cell *matCellDef="let importError" class="text-left"> {{importError.resolution}} </td>
    </ng-container>

    <!-- CreatedOn -->
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Created On</th>
      <td mat-cell *matCellDef="let importError"
      class="text-left"> {{importError.createdOn | date: "MMMM d, yyyy h:mm a"}} </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="text-left">Actions</th>
      <td mat-cell *matCellDef="let importError" class="text-left">
        @if (importError.code === 'NotAllMenuClientProductMappingsFound') {
          <button type="button" data-testid="missing-client-product-button" mat-raised-button color="primary" (click)="importMissingClientProducts(importError.objectId, importError.clientId)" class="action-button" [disabled]="isImporting(importError.objectId)">
            <mat-icon data-testid="missing-client-product-icon" fontIcon="sync" class="admin-home-button-icon" [ngClass]="{ 'spin': isImporting(importError.objectId) }">sync</mat-icon>Import Products
          </button>
        }
        @if (importError.code === 'NotAllMenuItemsFound') {
          <button type="button" data-testid="missing-menu-button" mat-raised-button color="primary" (click)="importMissingMenu(importError)" class="action-button" [disabled]="isImportingMenu(importError)">
            <mat-icon data-testid="missing-menu-icon" fontIcon="sync" class="admin-home-button-icon" [ngClass]="{ 'spin': isImportingMenu(importError) }">sync</mat-icon>Import Menu
          </button>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator #paginator
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    [showFirstLastButtons]="false"
    [pageSize]="pageSize()"
    [pageIndex]="pageIndex()"
    [length]="totalCount()"
    aria-label="Select page"
    (page)="onPageChange($event)"
    >
  </mat-paginator>
</dish-admin>
